"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSelected = void 0;
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _layoutTheme = require("../../styles/layout-theme.js");
var IconSelected = exports.IconSelected = _styledComponents["default"].div.withConfig({
  displayName: "IconSelected",
  componentId: "sc-1a4w7w-0"
})(["position:absolute;display:inline-flex;inset-inline-end:", ";"], (0, _layoutTheme.cssSpacing)('tighter', '12px'));